import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import { Grid, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface FoodListTitleProps {
    restaurantOfferStore: RestaurantOfferStore;
}

const FoodListTitle: React.FC<FoodListTitleProps> = observer(({ restaurantOfferStore }) => {

    const { selectedFoodCategory, foodSearchResult, foodSearchText } = restaurantOfferStore;

    if (foodSearchResult !== undefined) {
        return (
            <Typography>{`Rezultati pretrage za ${foodSearchText} (${foodSearchResult.length})`}</Typography>
        )
    }
    else {
        return (
            <Grid container justifyContent="flex-start" alignItems="center">
                <img
                    src={require(`../../../../assets/offer/food-category/${selectedFoodCategory!.iconName}.png`)}
                    height={32} />
                <Typography
                    ml={1}
                    fontWeight={600}>
                    {selectedFoodCategory!.name}
                </Typography>
            </Grid>
        )
    }
})

export default FoodListTitle;